import React, { useEffect, useMemo } from "react";

import * as actions from "../../../_redux/orders/ordersActions";
import * as uiHelpers from "../OrdersListUIHelpers";
import { useOrdersListUIContext } from "../OrdersListUIContext";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import * as formatters from "./column-formatters/index";
import BootstrapTable from "react-bootstrap-table-next";
import {
  getHandlerTableChange,
  getSelectRow,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../_metronic/_helpers";

export function OrdersListTable() {
  const ordersListUIContext = useOrdersListUIContext();
  const orderListUIProps = useMemo(() => {
    return {
      ids: ordersListUIContext.ids,
      setIds: ordersListUIContext.setIds,
      queryParams: ordersListUIContext.queryParams,
      setQueryParams: ordersListUIContext.setQueryParams,
      openViewOrderPage: ordersListUIContext.openViewOrderPage,
    };
  }, [ordersListUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.orders }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();

  useEffect(() => {
    orderListUIProps.setIds([]);
    dispatch(actions.fetchOrders(orderListUIProps.queryParams));
  }, [orderListUIProps.queryParams, dispatch]);

  const columns = [
    {
      dataField: "name",
      text: "سفارش",
      formatter: formatters.NameLinkFormatter,
    },
    {
      dataField: "inventory",
      text: "انبار",
      formatter: formatters.InventoryNameFormatter,
    },
    {
      dataField: "status",
      text: "وضعیت سفارش",
      formatter: formatters.StatusColumnFormatter,
    },
    {
      dataField: "createDate",
      text: "تاریخ ثبت سفارش",
      formatter: formatters.DateColumnFormatter,
    },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: orderListUIProps.queryParams.pageSize,
    page: orderListUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses={"table-responsive"}
                classes={
                  "table table-head-custom table-vertical-center overflow-hidden"
                }
                bootstrap4
                bordered={false}
                remote
                keyField={"id"}
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  orderListUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: orderListUIProps.ids,
                  setIds: orderListUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
